import React from 'react'
import "./Heading_banner_section.css"
import Common_breadcrumb from '../common_breadcrumb/Common_breadcrumb'
import Common_Heading from '../common_Heading/Common_Heading'

function Heading_banner_section({headingText,subHeadingText,breadcrumbItems}) {
  return (
  <>
   <section className="heading_banner_section">
          <div className="custom_container">
            {breadcrumbItems && (
              <Common_breadcrumb items={breadcrumbItems} />
            )}
            
            <Common_Heading headingText={headingText} subHeadingText={subHeadingText}/>
          </div>
        </section>
  </>
  )
}

export default Heading_banner_section